import { URL as NodeURL, pathToFileURL } from "url";
import type { WorkerOptions } from "worker_threads";
import { Worker as NodeWorker, isMainThread, parentPort } from "worker_threads";

class WorkerPolyfill extends NodeWorker {
  constructor(scriptUrl: string | NodeURL, options?: WorkerOptions) {
    const resolved: string =
      scriptUrl instanceof NodeURL ? scriptUrl.toString() : pathToFileURL(scriptUrl).toString();
    super(resolved, options);
  }

  addEventListener(event: "message" | "error", listener: (...args: any[]) => void) {
    if (event === "message") this.on("message", listener);
    if (event === "error") this.on("error", listener);
  }

  removeEventListener(event: "message" | "error", listener: (...args: any[]) => void) {
    if (event === "message") this.off("message", listener);
    if (event === "error") this.off("error", listener);
  }
}

const Worker = isMainThread ? WorkerPolyfill : parentPort;
export { Worker, parentPort };

import { globalServiceRegistry } from "../di";
import { WORKER_SERVER, WorkerServerBase } from "./WorkerServerBase";
export { WORKER_SERVER };
export class WorkerServer extends WorkerServerBase {
  constructor() {
    parentPort?.addEventListener("message", async (event) => {
      const msg = {
        type: event.type,
        // @ts-expect-error - Ignore type mismatch between standard MessageEvent and our message type
        data: event.data,
      };
      await this.handleMessage(msg);
    });
    super();
  }
}

globalServiceRegistry.register(WORKER_SERVER, () => new WorkerServer(), true);
